import React from 'react';
import { useParams, useHistory } from 'react-router';
import AccountHeaderPresenter from './AccountHeaderPresenter';

interface Props {
  title?: string;
  onClickBack?: () => void;
}

const AccountHeaderContainer: React.FC<Props> = ({ title, onClickBack }) => {
  const history = useHistory();
  const { urlParam } = useParams<any>();

  const onClickBackDefault = () => {
    history.goBack();
  };

  return (
    <AccountHeaderPresenter
      title={title}
      urlParam={urlParam}
      onClickBack={onClickBack ?? onClickBackDefault}
    />
  );
};

export default AccountHeaderContainer;
